export const formatDate = (value) => {
  if (!value) return "—";
  return new Date(value).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};


export const formatDateTime = (value) => {
  if (!value) return "—";
  return new Date(value).toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
};


export const formatHours = (value) => `${Number(value || 0).toFixed(2)} hrs`;


export const formatMinutes = (value) => `${value || 0} min`;


export const extractTime = (value) => {
  if (!value) return "—";
  return new Date(value).toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
  });
};


const friendlyErrors = {
  "Duplicate punch prevented for the day": "Attendance is already completed for today.",
  "No open attendance record available for clock out": "You need an active clock-in before you can clock out.",
  "Attendance is blocked during approved leave": "Attendance is blocked because you already have approved leave for today.",
  "QR session expired": "This QR session has expired. Please ask your admin to generate a fresh one.",
  "QR session not found or inactive": "This QR session is no longer active. Please scan a fresh code.",
  "You can only use your assigned attendance method": "This punch method is not assigned to you. Please use the attendance method shown on your home page.",
  "No valid attendance method is assigned to this employee": "Your attendance method is not assigned yet. Please ask your Company Admin to update your profile.",
  "Your assigned attendance feature is disabled for your company. Please contact your admin.": "Your assigned attendance method is currently disabled. Please contact your admin.",
  "Invalid or expired token": "Your sign-in session is no longer valid. Please sign in again.",
  "Password reset link is invalid or already used": "This password setup link has already been used. Please sign in again with your temporary password to generate a fresh setup flow.",
  "Password reset link has expired": "Your password setup link has expired. Please sign in again with your temporary password to generate a fresh one.",
};


export const getErrorMessage = (error) => {
  const rawMessage = error?.response?.data?.detail || error.message || "Something went wrong";
  return friendlyErrors[rawMessage] || rawMessage;
};